export const PLS_FEATURE_ENABLED = 'PLS.PLSFeatureEnabled';
